var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    viewBox: "0 0 1024 1024",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3765_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M967,419.5H340.3V114.4h580.5c25.4,0,46.1,20.7,46.1,46.1V419.5z M400.3,359.5H907V174.4H400.3V359.5z",
    id: "XMLID_17_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684,665H57V359h627V665z M117,605h507V419H117V605z",
    id: "XMLID_14_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.3,419.5H57v-259c0-25.4,20.7-46.1,46.1-46.1h297.2V419.5z M117,359.5h223.3V174.4H117V359.5z",
    id: "XMLID_11_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.9,909.6H340.3V604.5H967v259C967,888.9,946.3,909.6,920.9,909.6z M400.3,849.6H907V664.5H400.3V849.6z",
    id: "XMLID_8_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.3,909.6H103.1c-25.4,0-46.1-20.7-46.1-46.1v-259h343.3V909.6z M117,849.6h223.3V664.5H117V849.6z",
    id: "XMLID_5_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967,665H624V359h343V665z M684,605h223V419H684V605z",
    id: "XMLID_2_"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_20_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_21_"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_22_"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrick);
export default __webpack_public_path__ + "static/media/brick.ed4c81d699009690f4cc8bdd7291baf1.svg";
export { ForwardRef as ReactComponent };